import { SortByOption } from './SortBy';

export const sortOptions: SortByOption[] = [
    { text: 'Highest Earnings', value: 'MaxRebate desc', iconType: 'arrows' },
    { text: 'Most Popular', value: 'PopularityRank asc', iconType: 'list' },
    { text: 'Name(A-Z)', value: 'Name asc', iconType: 'a-z' },
    { text: 'Name(Z-A)', value: 'Name desc', iconType: 'a-z' },
];
